/* eslint-disable */
/**
 * 继承Date，将 Date 转化为指定格式的String
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * @module util/DateUtil
 * @example
 * (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 * @param fmt
 * @returns {*}
 */
class DateUtil extends Date {
  static format (date, fmt) {
    if (typeof date === typeof 0) {
      date = new Date(date)
    }
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds(), // 毫秒
    }
    const week = {
      '0': '日',
      '1': '一',
      '2': '二',
      '3': '三',
      '4': '四',
      '5': '五',
      '6': '六'
    }
    let replaceFmt = (fmt && fmt !== '') ? fmt : ''; // 2017.2.10更新，设置默认值，保证replace时不会因为没有赋值而报错
    if (/(y+)/.test(fmt)) {
      replaceFmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length))
    }
    if (/(E+)/.test(fmt)) {
      replaceFmt = replaceFmt.replace(RegExp.$1, (`${((RegExp.$1.length>1) ?  "星期" : "周")}${week[date.getDay()]}`))
    }
    Object.keys(o).forEach((k) => {
      if (new RegExp(`(${k})`).test(fmt)) {
        replaceFmt = replaceFmt.replace(RegExp.$1, (RegExp.$1.length === 1) ?
          (o[k]) :
          ((`00${o[k]}`).substr((`${o[k]}`).length)))
      }
    })
    return replaceFmt
  }
}

export default DateUtil
